import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPhoneTopDynamicIsland: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconPhoneTopDynamicIsland"><Path fillRule="evenodd" clipRule="evenodd" d="M17 3C19.2091 3 21 4.79086 21 7V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V7C3 4.79086 4.79086 3 7 3H17ZM11 5C10.5858 5 10.25 5.33579 10.25 5.75C10.25 6.16421 10.5858 6.5 11 6.5H13C13.4142 6.5 13.75 6.16421 13.75 5.75C13.75 5.33579 13.4142 5 13 5H11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPhoneTopDynamicIsland;
